import Text from "../../../commons/Text";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import imgWebp from "../../../../assets/img/landings/nextres/rocket.webp";
import imgPng from "../../../../assets/img/landings/nextres/rocket.png";
import { v4 as uuid } from "uuid";
import btnClasses from "../../../commons/Button.module.scss";
import RequestDemo from "../../../Button/RequestDemo";

export default function Problem({ title, text, tooltip }) {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.animation}>
            <div className={classes.image}>
              <picture>
                <source srcSet={imgWebp} type="image/webp" />
                <source srcSet={imgPng} type="image/png" />
                <img src={imgPng} alt={title} width={160} height={192} />
              </picture>
            </div>
            <ul className={classes.list}>
              {tooltip.map((item) => (
                <li className={classes.item} key={uuid()}>
                  <div className={classes.badge}>
                    <h3>{item.title}</h3>
                  </div>
                  <div className={classes.card}>
                    <h3>{item.hiddenTitle}</h3>
                    <p>{item.text}</p>
                  </div>
                </li>
              ))}
            </ul>
            <span />
          </div>
          <div className={classes.content}>
            <Title title={title} number={"01"} />
            <Text text={text} />
            <RequestDemo className={btnClasses.button} />
          </div>
        </div>
      </div>
    </section>
  );
}
